import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{
 *   $el: HTMLElement;
 *   pushLink: HTMLElement[];
 *   pushContent: HTMLElement[];
 * }} PushMenuProps
 */

/**
 * PushMenu
 * @augments {Base<PushMenuProps>}
 */
export default class PushMenu extends Base {
  static config = {
    name: 'PushMenu',
    refs: ['pushLink[]', 'pushContent[]'],
  };

  /**
   * Mounted hook
   */
  mounted() {
    this.$refs.pushLink.forEach((link, index) => {
      const pushContent = this.$refs.pushContent[index];
      const linkclick = link.querySelector('button');

      linkclick.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Set all pushContent to opacity 0 except the clicked one
        this.$refs.pushContent.forEach((content) => {
          if (content !== pushContent) {
            content.style.opacity = '0';
          }
        });

        // Toggle between base and selected push content
        if (pushContent.style.opacity === '1') {
          pushContent.style.opacity = '0';
        } else {
          pushContent.style.opacity = '1';
        }
      });
    });
  }
}
